import { useTypedSelector } from '@/store/store';
import { selectCatalogMenuResource } from '@/store/reducers/tager/menus';

export function useCatalogMenuResource() {
  return useTypedSelector((state) => selectCatalogMenuResource(state));
}
